export default __webpack_public_path__ + "static/media/fodrixiconnew.b71654fe.webp";